export default __webpack_public_path__ + "static/media/course-1-2.9969a5e6.jpg";